// extracted by mini-css-extract-plugin
module.exports = {"container":"ProBlogPost_container__Aj7UP","title":"ProBlogPost_title__oLZZN","name":"ProBlogPost_name__jGEnW"};